import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// helpers
import { centsToDollars } from 'lib/helpers/money'
import {
  cartProductTotal,
  volumeDiscountUpgradeDays,
  volumeDiscountUpgradeAmount
} from 'lib/cart/decorators/cartProduct'

const VolumeDiscountHint = props => {
  const { cartProduct, account } = props

  // only show hint for selected day pass products with available volume discounts
  if (
    !cartProduct.product ||
    !cartProduct.product.volumeDiscountDays ||
    !cartProduct.days ||
    cartProduct.selectedType !== 'day-pass'
  ) {
    return null
  }

  // determine if volume discount is less expensive than day pass
  const total = cartProductTotal(cartProduct, account)
  const amountForDiscount = volumeDiscountUpgradeAmount(cartProduct, account)
  if (total < amountForDiscount) {
    return null
  }

  // determine the number of days required for volume discount
  const daysForDiscount = volumeDiscountUpgradeDays(cartProduct)

  return (
    <Box display='flex' alignItems='center'>
      <Typography ml={1} component='span' variant='body2' color='error'>
        Hint: buying {daysForDiscount} days for{' '}
        {centsToDollars(amountForDiscount)} costs less!
      </Typography>
    </Box>
  )
}

export default VolumeDiscountHint
